module.exports = __webpack_public_path__ + "static/media/usage_immeuble.0f50d5c9.png";